import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewChild } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ISOTService } from '../../services';
import { CoreLogService } from "../../../core/services/log.service";
import { NumberPad } from "../../directives/numberPad/numberPad.component";

export interface voucherNumberPadDialogConfig {
  sot_service: ISOTService;
  /** When true, the dialog is shown as part of the benefits-redemption flow
   *  and uses the benefit-specific title langkey. */
  isBenefitsRedemption?: boolean;
}

@Component({
  selector: "voucherNumberPadDialog",
  templateUrl: "./voucherNumberPadDialog.component.html",
  styleUrls: ["./voucherNumberPadDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class VoucherNumberPadDialogComponent {
  private _sotService: ISOTService;
  @ViewChild("numberPad") numberPad: NumberPad;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , public dialogRef: MatDialogRef<VoucherNumberPadDialogComponent, string | "cancel">
    , @Inject(MAT_DIALOG_DATA) public voucherNumberPadDialogConfig: voucherNumberPadDialogConfig
    , private _coreLogService: CoreLogService) {
    const me = this;
    me._sotService = voucherNumberPadDialogConfig.sot_service;
  }

  public requiredVoucherLength: number = 18;

  public get voucherCode(): string {
    const me = this;
    return me.numberPad.numberPadResult;
  }

  public get submitDisabled() {
    const me = this;
    return me.numberPad.submitDisabled;
  }

  public submit(): void {
    const me = this;
    if (!me.submitDisabled) {
      me.dialogRef.close(me.voucherCode);
    } else {
      me.numberPad.toggleInputValid();
    }
    me.PushChanges();
  }

  public cancel(): void {
    const me = this;
    me.dialogRef.close("cancel");
  }

  public ngOnInit(): void {
    const me = this;
    me.PushChanges();
  }
  public get isModeOne(): boolean {
    return this.voucherNumberPadDialogConfig.sot_service.Accessabilty.useModeOne;
  }
  public get isModeTwo(): boolean {
    return this.voucherNumberPadDialogConfig.sot_service.Accessabilty.useModeTwo;
  }

  public get titleKey(): string {
    const me = this;
    return me.voucherNumberPadDialogConfig.isBenefitsRedemption
      ? "voucherscan_benefits_title"
      : "voucherscan_manual_enter_text";
  }
  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("VoucherNumberPadDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }
}